import React from "react";
import styles from "../Styles/TextDisplay.module.scss";

export const TextDisplay: React.FC = props => (
  <div className={styles.textDisplay}>{props.children}</div>
);
